import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './header-grid-cell.module.css'

export const HeaderGridCell = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {className, ...other} = props

  return <div ref={ref} role="columnheader" aria-colspan={1} className={clsx(className, styles.Box)} {...other} />
})

HeaderGridCell.displayName = 'HeaderGridCell'
